import { Badge } from "../ui/badge";
import type { OrderStatus } from "../../../../shared/const";
import { useLanguage } from "../../contexts/LanguageContext";

/* 反饋 6：每狀態實心 soft 底色＋同色系深字＋細邊框（light/dark 雙模式）。
   sky=歷史報價流程、emerald=已確認、amber=派遣中、teal=服務中、
   stone=已完成（暖灰，配茶湯底）、rose=拒絕/取消。 */
const TONE_CLASS = {
  sky: "border-sky-600/30 bg-sky-100 text-sky-900 dark:border-sky-400/30 dark:bg-sky-400/15 dark:text-sky-200",
  emerald:
    "border-emerald-600/30 bg-emerald-100 text-emerald-900 dark:border-emerald-400/30 dark:bg-emerald-400/15 dark:text-emerald-200",
  amber: "border-amber-600/30 bg-amber-100 text-amber-900 dark:border-amber-400/30 dark:bg-amber-400/15 dark:text-amber-200",
  teal: "border-teal-600/30 bg-teal-100 text-teal-900 dark:border-teal-400/30 dark:bg-teal-400/15 dark:text-teal-200",
  stone: "border-stone-500/30 bg-stone-200/80 text-stone-700 dark:border-stone-400/30 dark:bg-stone-400/15 dark:text-stone-300",
  rose: "border-rose-600/30 bg-rose-100 text-rose-900 dark:border-rose-400/30 dark:bg-rose-400/15 dark:text-rose-200",
} as const;

const CONFIG: Record<OrderStatus, {
  label: { "zh-TW": string; "en-US": string; "zh-CN": string };
  tone: keyof typeof TONE_CLASS;
}> = {
  pending: { label: { "zh-TW": "待處理", "en-US": "Pending", "zh-CN": "待处理" }, tone: "sky" },
  quoting: { label: { "zh-TW": "報價中", "en-US": "Quoting", "zh-CN": "报价中" }, tone: "sky" },
  quoted: { label: { "zh-TW": "報價已送出", "en-US": "Quoted", "zh-CN": "报价已送出" }, tone: "sky" },
  rejected_quote: { label: { "zh-TW": "報價被退回", "en-US": "Quote rejected", "zh-CN": "报价被退回" }, tone: "rose" },
  confirmed: { label: { "zh-TW": "已確認", "en-US": "Confirmed", "zh-CN": "已确认" }, tone: "emerald" },
  dispatching: { label: { "zh-TW": "派遣中", "en-US": "Dispatching", "zh-CN": "派遣中" }, tone: "amber" },
  rejected_dispatch: { label: { "zh-TW": "派遣被拒", "en-US": "Dispatch rejected", "zh-CN": "派遣被拒" }, tone: "rose" },
  active: { label: { "zh-TW": "服務中", "en-US": "In service", "zh-CN": "服务中" }, tone: "teal" },
  completed: { label: { "zh-TW": "已完成", "en-US": "Completed", "zh-CN": "已完成" }, tone: "stone" },
  cancelled: { label: { "zh-TW": "已取消", "en-US": "Cancelled", "zh-CN": "已取消" }, tone: "rose" },
};

export function OrderStatusBadge({ status, size = "default" }: { status: OrderStatus; size?: "default" | "sm" }) {
  const { t } = useLanguage();
  const cfg = CONFIG[status];
  return (
    <Badge variant="outline" size={size} className={TONE_CLASS[cfg.tone]}>
      {t(cfg.label)}
    </Badge>
  );
}
